export default {
  setLoadingState(state, isLoading = false) {
    state.ui.isLoading = isLoading;
  },
  setDataTableFilters(state, data) {
    state.dataTableFilters = data.data;
  },
};
